export default __webpack_public_path__ + "static/media/LOGOUT_ICONA.9254b122.svg";